<template>
  <v-slide-y-transition mode="out-in">
    <live-eks></live-eks>    
  </v-slide-y-transition>
</template>
<script>
import LiveEks from './live-eks';
//import LiveLeg from './live-leg';
//import LiveDpd from './live-dpd';

export default {
  components: {
    LiveEks,
    //LiveLeg,
    //LiveDpd
  },
  data () {
    return {
      //chat: null,
      //selectedTab: null,
    };
  },
  computed: {
    showFormEks() {
      return this.$route.query.mode == 1;
    },
    showFormLeg() {
      return this.$route.query.mode == 2;
    },
    showFormDpd() {
      return this.$route.query.mode == 3;
    },            
  },
};
</script>

